/**
 * Parte empleados del cierre para no superar el límite 413 del servidor.
 */
export function partirEmpleadosCierre(empleados = [], maxBytes = 250000, maxPorLote = 8) {
  const lista = Array.isArray(empleados) ? empleados : [];
  if (lista.length === 0) return [];

  const lotes = [];
  let actual = [];
  let bytes = 2;

  lista.forEach((emp) => {
    const serializado = JSON.stringify(emp);
    const tamano = typeof serializado === 'string' ? serializado.length : 0;
    const llena = actual.length > 0
      && (actual.length >= maxPorLote || bytes + tamano + 1 > maxBytes);
    if (llena) {
      lotes.push(actual);
      actual = [];
      bytes = 2;
    }
    actual.push(emp);
    bytes += tamano + 1;
  });

  if (actual.length) lotes.push(actual);
  return lotes;
}

export default partirEmpleadosCierre;
